export function isAdmin(email?: string | null) {
  return email && email.includes('@blumint.io');
}
